;(function (angular, _) {
  'use strict';
  angular.module('kilo.common.directives')
    .directive('clickTimeout', ClickTimeoutDirective)

  ClickTimeoutDirective.$inject = [
    // Angular
    '$timeout'
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]
  function ClickTimeoutDirective (
    // Angular
    $timeout
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {

    return {
      restrict: 'A',
      scope: {
        clickTimeout: '=?'
      },
      link: function (scope, element, attrs) {
        element.bind('click', function (event) {
          // Check if element haven't disabled or ng-disabled attribute
          if (!_.intersection(_.keys(attrs), ['disabled', 'ngDisabled']).length) {
            element.prop('disabled', true)
            $timeout(function () {
              element.prop('disabled', false)
            }, scope.clickTimeout || 3000)
          }
        })
      }
    }
  }
})(window.angular, window._)
